
import store from "@/store.js"

function evaluateFc(string) {
    if (!string || Object.keys(store.getters.actualTemplate).length === 0) {
        return null;
    }
    if (typeof string === 'boolean') {
        string = string.toString();
    }
    var newString = reparse(string, store.getters.actualTemplate);
    return eval(newString);
}

function checker(string) {
    if (!string || Object.keys(store.getters.actualTemplate).length === 0) {
        return null;
    }
    var newString = reparse(string, store.getters.actualTemplate, false);
    return /^[*/+\-()0123456789]+$/.test(newString);
}

function reparse(string, wholeTemplate, evaluateData) {
    var newString = string;
    while (newString.includes("ref(\"")) {
        var index = newString.indexOf("ref(\"");
        var refToEnd = newString.substring(index);
        index = refToEnd.indexOf("\")");
        var ref = refToEnd.substring(0, index + 2);
        if (evaluateData) {
            try {
                newString = newString.replace(ref, eval(getRefWhole(ref, wholeTemplate, true)));
            }
            catch (e){
                newString = newString.replace(ref, getRefWhole(ref, wholeTemplate, true));
            }
        }
        else {
            newString = newString.replace(ref, getRefWhole(ref, wholeTemplate, false));
        }
    }
    return newString
}

function getRefWhole(ref, wholeTemplate, evaluateData) {
    if (!wholeTemplate) {
        return null;
    }
    var id = ref.replace("ref(\"", "").replace("\")", "");

    // test if id contains only chars and numbers
    if (!(/^[a-zA-Z0-9.]+$/.test(id))) {
        console.log("notAllowedChar");
        return null;
    }
    if (wholeTemplate.pages) {
        for (var i = 0; i < wholeTemplate.pages.length; i++){
            var value = getRefStructure(id, wholeTemplate.pages[i], wholeTemplate, evaluateData);
            if (value) {
                if (typeof value === 'string') {
                    return '"' + value +'"'
                }
                return value;
            }
        }
    }
    return null;
}

function getRefStructure(id, structure, wholeTemplate, evaluateData) {
    if (!wholeTemplate) {
        return null;
    }
    if (structure.id == id) {
        if (structure.calculate) {
            return reparse(structure.calculate, wholeTemplate, evaluateData);
        }
        return structure.value;
    }
    if (structure.structure) {
        for (var i = 0; i < structure.structure.length; i++){
            var value = null;
            try {
                value = eval(getRefStructure(id, structure.structure[i], wholeTemplate, true));
            }
            catch (e) {
                value = getRefStructure(id, structure.structure[i], wholeTemplate, true);
            }
            if (value) {
                return value;
            }
        }
    }
    return null;
}

function setKey(id, key, value) {
    var wholeTemplate = store.getters.actualTemplate;
    if (wholeTemplate.pages) {
        for (var i = 0; i < wholeTemplate.pages.length; i++) {
            var output = setKeyStructure(id, key, value, wholeTemplate.pages[i]);
            if (output) {
                return true
            }
        }
    };
    return false
}

function setKeyStructure(id, key, value, structure) {
    if (structure.id == id) {
        structure[key] = value
        return true;
    }
    if (structure.structure) {
        for (var i = 0; i < structure.structure.length; i++){
            var output = setKeyStructure(id, key, value, structure.structure[i]);
            if (output) {
                return true
            }
        }
    }
    return false;
}

export const evaluate = {
    eval: evaluateFc,
    checker: checker,
    getRefWhole: getRefWhole,
    getRefStructure: getRefStructure,
    setKey: setKey
}
